<app-form-layout>
  <div class="comment-container">
    @if (!isCommentActive) {
      <div class="closed-container" aria-live="polite" role="region" aria-label="Comment period closed">
        <div class="closed-icon-wrapper" aria-hidden="true">
          <mat-icon>lock</mat-icon>
        </div>
        <h1>Comment Period Closed</h1>
        <div class="closed-message">
          @if (closedMessage) {
            <app-sanitized-html [html]="closedMessage" />
          } @else {
            <p>The public comment period for this project has ended.</p>
            <p>
              We appreciate the time and interest of everyone who participated. All comments submitted have been
              recorded and will be carefully considered as part of the project process.
            </p>
            <hr class="closed-divider" />
            <p class="closed-footer">If you have questions, please contact the project team directly.</p>
          }
        </div>
      </div>
    } @else if (!isSubmitted) {
      <div>
        <h1>
          @if (projectInfo?.ProjectName) {
            <span> Comment on {{ projectInfo?.ProjectName }} </span>
          } @else {
            Comment on the Project
          }
        </h1>
        <p class="description"><span class="required">*</span> Indicates a required field</p>
        <app-global-comment
          [projectInfo]="projectInfo"
          [subscribeSourceId]="this.subscribeSourceId"
          (formSubmitted)="handleFormSubmitted($event)"
        ></app-global-comment>
      </div>
    } @else {
      <div class="thanks-container" aria-live="polite">
        <h1>Thank You for Your Comment!</h1>
        <p role="alert">Your comment has been successfully submitted.</p>
        <div class="checkmark-container">
          <mat-icon class="checkmark">check_circle</mat-icon>
        </div>
        <div class="button-row">
          <button class="blue-button" (click)="resetForm()">Submit Another Comment</button>
        </div>
      </div>
    }
  </div>
</app-form-layout>
